import { ReactNode } from 'react'

export const cellHeightStyle = {
    short: 34,
    medium: 64,
    tall: 80,
} as const

export type CellHeight = keyof typeof cellHeightStyle

export type BodyProps = {
    children: ReactNode
    rowHeight: number
    start: number
    end: number
    rowCount: number
}

export function TableBody({ rowHeight, start, end, rowCount, children }: BodyProps) {
    const topPadding = start * rowHeight
    const bottomPadding = (rowCount - end) * rowHeight

    return (
        <>
            {topPadding > 0 && <div style={{ height: topPadding }} />}
            {children}
            {bottomPadding > 0 && <div style={{ height: bottomPadding }} />}
        </>
    )
}
